import react, { useEffect, useState } from "react";
import "./ApplicantCard.css";
import { Button, Grid } from "@mui/material";
import ExpandCircleDownIcon from "@mui/icons-material/ExpandCircleDown";
import { useNavigate } from "react-router-dom";
import {
  applicantCardTypeEnum,
  jobPostingCardTypeEnum,
} from "../../constants/constants";
import { Notescall } from "../../Icons/Notescall";
import { Notesemail } from "../../Icons/Notesemail";
import { GetTimeZone } from "../../_utilities/GetTimeZone";
import { DashboardPlusicon } from "../../Icons/DashboardPlusicon";
import { PublicView } from "../../Icons/publicView";
import { PersionView } from "../../Icons/persionView";

const ApplicantCard = ({
  data: rawData,
  isAction,
  title,
  actionLink,
  type,
  nodata,
  isAddSection,
  onReceiveProps,
  onDowloadHandler,
}) => {
  // Always normalize data to an array to prevent .map errors
  const data = Array.isArray(rawData)
    ? rawData
    : rawData && typeof rawData === "object" && rawData !== null
      ? [rawData]
      : [];
  const [isExpanded, setIsExpanded] = useState(true);
  // const [accordionText, setAccordionText] = useState("View all");
  const [isAccordion, setIsAccordion] = useState(false);
  const navigate = useNavigate();

  // const handleToggle = () => {
  //     setIsExpanded(!isExpanded);
  //     setAccordionText(isExpanded ? "View less" : "View all");
  // };

  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";

  // useEffect(() => {
  //     if (type === applicantCardTypeEnum.LIST_WITH_JUSTIFY && data.length > 2) {
  //         setIsAccordion(true);
  //     } else {
  //         setIsAccordion(false);
  //     }
  // }, [type, data]);

  const customLayout = () => {
    return (
      <div>
        {data.length > 0 &&
          data.map((elem, i) => {
            return (
              <div key={i} className="applicant-card-notes">
                <div>
                  <div className="usericon">
                    {elem.noteType === "Call" ? (
                      <Notescall
                        primaryColor={storedTheme?.primaryColor}
                        primaryFontColor={storedTheme?.primaryFontColor}
                        width={40}
                        height={40}
                      />
                    ):
                    (elem.noteType === "Public" && elem.moduleType === "projects")? (
                      <PersionView
                        primaryColor={storedTheme?.secondaryColor}
                        primaryFontColor={storedTheme?.secondaryFontColor}
                        width={40}
                        height={40}
                      />
                    ): elem.noteType === "Public"? (
                      <PublicView
                        secondaryColor={storedTheme?.secondaryColor}
                        secondaryFontColor={storedTheme?.secondaryFontColor}
                        width={40}
                        height={40}
                      />
                    ) : (
                      <Notesemail
                        primaryColor={storedTheme?.primaryColor}
                        primaryFontColor={storedTheme?.primaryFontColor}
                        width={40}
                        height={40}
                      />
                    )}
                  </div>
                  <div className="jobnote">
                    <b>{elem?.firstName + " " + elem?.lastName}</b>
                    <div
                      style={{ maxWidth: "calc(100% - 60px)" }}
                      dangerouslySetInnerHTML={{ __html: elem.notes }}
                    ></div>
                    <span className="createdDate">
                      {elem?.createdAt ? GetTimeZone(elem.createdAt) : ""}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        {data.length === 0 && <h1 className="no-Data">{nodata}</h1>}
      </div>
    );
  };

  const renderingUI = (type, data) => {
    switch (type) {
      case applicantCardTypeEnum.LIST:
        return (
          <div>
            <ul
              className={data.length > 0 && data[0].name ? "column-view" : ""}
            >
              {data?.map((item, index) => {
                if (item?.name) {
                  return <li key={index}>{item.name}</li>;
                } else {
                  return <li key={index}>{item?.name ?? item}</li>;
                }
              })}
            </ul>
          </div>
        );
      case applicantCardTypeEnum.LIST_WITH_COLUMN:
        return (
          <table
            className={
              title === "Associated Jobs" ||
              title === "Documents" ||
              title === "Notes" ||
              title === "Audit Info"
                ? "list-with-column border"
                : title === "Recruiting Team"
                  ? "list-with-column no-wrap"
                  : "list-with-column"
            }
          >
            {data?.length > 0 &&
              data.map((item, index) => (
                <tr key={index}>
                  <td>
                    {typeof item?.key === "string" ? (
                      item?.key
                    ) : (
                      <>
                        {item?.key.map((key, index) => (
                          <div style={{ marginBottom: "9px" }} key={index}>
                            {key}
                          </div>
                        ))}
                      </>
                    )}
                  </td>
                  <td>
                    {typeof item?.key === "string" ? (
                      ":"
                    ) : (
                      <>
                        {item?.key.map((key, index) => {
                          if (key) {
                            return (
                              <div style={{ marginBottom: "9px" }} key={index}>
                                :
                              </div>
                            );
                          }
                        })}
                      </>
                    )}
                  </td>
                  <td>
                    {typeof item?.value === "string" ? (
                      item?.value
                    ) : typeof item?.key !== "string" ? (
                      <>
                        {item?.value.map((value, index) => {
                          let fileType = "";
                          if (item?.fileType) {
                            fileType =
                              item.fileType === "pdf" ? (
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/assests/img/pdf.svg"
                                  }
                                  alt=""
                                  className="pdficon"
                                />
                              ) : (
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/assests/img/docx.svg"
                                  }
                                  alt=""
                                  className="pdficon"
                                />
                              );
                          }
                          return (
                            <div
                              style={{
                                marginBottom: "9px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                              key={index}
                            >
                              {index === 2 && nodata.includes("documents")
                                ? fileType
                                : ""}{" "}
                              {value}
                            </div>
                          );
                        })}
                      </>
                    ) : (
                      item?.value.join(", ")
                    )}
                  </td>
                </tr>
              ))}
          </table>
        );
      case applicantCardTypeEnum.LIST_WITH_JUSTIFY:
        return (
          <>
            {data?.length > 0 &&
              data?.map((item, index) => {
                return (
                  <Grid
                    container
                    spacing={0}
                    key={index}
                    className="list-with-justify"
                  >
                    <Grid item xs={7} className="justify-item-left">
                      <h4>{item?.title ? item.title : ""}</h4>
                      <p>{item?.organization ? item.organization : ""}</p>
                      <div className="mobile-detail-text">
                        <p>
                          {item?.workingOn ? item.workingOn : ""}{" "}
                          {item?.type ? `- ${item.type}` : ""}
                        </p>
                      </div>
                    </Grid>
                    <Grid item xs={5} className="justify-item-right">
                      <h4>{item?.workingOn ? item.workingOn : ""}</h4>
                      <p>{item?.type ? item.type : ""}</p>
                    </Grid>
                  </Grid>
                );
              })}
          </>
        );
      case jobPostingCardTypeEnum.DATA:
        return <div dangerouslySetInnerHTML={{ __html: data }}></div>;
      case jobPostingCardTypeEnum.SERIAL_NUMBER_LIST:
        return (
          <div className="question-list">
            {data.map((q, i) => (
              <div key={q?.id} className="question-item">
                <div className="question-number">{i + 1}</div>
                <div className="question-text">{q?.question}</div>
              </div>
            ))}
          </div>
        );
      case jobPostingCardTypeEnum.LIST_WITH_GROUP:
        return (
          <div className="skills-container">
            {data.map((group) => (
              <div key={group?.id} className="skills-section">
                <h4>{group?.groupName}</h4>
                <ul>
                  {group?.skillsList &&
                    group.skillsList?.map((skill, i) => (
                      <li key={i}>{skill}</li>
                    ))}
                </ul>
              </div>
            ))}
          </div>
        );
      case jobPostingCardTypeEnum.TABLE:
        return (
          <table>
            {data.length > 0 &&
              data?.map((item) => (
                <tr
                  key={item?.id}
                  style={{ display: "block", marginBottom: "10px" }}
                >
                  <td valign="top" style={{ lineHeight: "1.6" }} width="130px">
                    {item?.key}
                  </td>
                  <td valign="top" style={{ lineHeight: "1.6" }} width="15px">
                    :
                  </td>
                  <td valign="top" style={{ lineHeight: "1.6" }}>
                    {item?.value}
                  </td>
                </tr>
              ))}
          </table>
        );
      case jobPostingCardTypeEnum.LIST_WITH_LABEL:
        return (
          <div className="badge-wrapper">
            {data.map((item) => (
              <div
                key={item.label}
                className="badge"
                style={{ backgroundColor: item.bg, color: item.color }}
              >
                <img
                  src={item?.icon}
                  alt=""
                  width="18px"
                  style={{ marginRight: "8px" }}
                />
                {item?.label}
              </div>
            ))}
          </div>
        );

      case jobPostingCardTypeEnum.LIST_WITH_CARD:
        return (
          <>
            {data?.length > 0 &&
              data?.map((item, index) => {
                const fileType =
                  item?.docType === "pdf" ? (
                    <img
                      src={process.env.PUBLIC_URL + "/assests/img/pdf.svg"}
                      alt=""
                      width="39px"
                    />
                  ) : (
                    <img
                      src={process.env.PUBLIC_URL + "/assests/img/docx.svg"}
                      alt=""
                      width="39px"
                    />
                  );
                return (
                  <div className="file-row">
                    <div className="file-icon">{fileType}</div>

                    <div className="file-info">
                      <div className="file-name">{item?.name}</div>
                      <div className="file-footer">
                        {item?.docType} ● {GetTimeZone(item?.date)}
                      </div>
                    </div>

                    <div
                      className="action-icon"
                      onClick={(e) => onDowloadHandler(item)}
                    >
                      <svg
                        id="surface1"
                        xmlns="http://www.w3.org/2000/svg"
                        width="21.617"
                        height="23.966"
                        viewBox="0 0 21.617 23.966"
                      >
                        <path
                          id="Path_24419"
                          data-name="Path 24419"
                          d="M237.853,18.217H240.5l-4.049-4.26v2.851A1.409,1.409,0,0,0,237.853,18.217Zm0,0"
                          transform="translate(-225.381 -13.304)"
                          fill="#3b4046"
                        />
                        <path
                          id="Path_24420"
                          data-name="Path 24420"
                          d="M192.612,236.336a6.452,6.452,0,1,0,6.452,6.452A6.458,6.458,0,0,0,192.612,236.336Zm3.466,7-3.164,3.4a.432.432,0,0,1-.319.135.42.42,0,0,1-.313-.135l-3.158-3.4a.434.434,0,0,1,.022-.61.44.44,0,0,1,.615.022l2.419,2.591V239.17a.432.432,0,0,1,.864,0v6.171l2.408-2.591a.43.43,0,1,1,.626.589Zm0,0"
                          transform="translate(-177.446 -225.273)"
                          fill="#3b4046"
                        />
                        <path
                          id="Path_24421"
                          data-name="Path 24421"
                          d="M8.082,15.657H3.39a.432.432,0,1,1,0-.864H8.368a7.669,7.669,0,0,1,1.1-1.89H3.39a.432.432,0,0,1,0-.864h6.895a7.433,7.433,0,0,1,4.886-1.857c.178,0,.324.016.54.032V5.777H12.471A2.275,2.275,0,0,1,10.2,3.5V0H1.922A1.932,1.932,0,0,0,0,1.949V18.427a1.914,1.914,0,0,0,1.922,1.927H8.428a7.374,7.374,0,0,1-.345-4.7ZM3.39,9.34H8.86a.432.432,0,0,1,0,.864H3.39a.432.432,0,0,1,0-.864Zm0,0"
                          fill="#3b4046"
                        />
                      </svg>
                    </div>
                  </div>
                );
              })}
          </>
        );
      case applicantCardTypeEnum.CUSTOM_LAYOUT:
        return <>{customLayout()}</>;
      case jobPostingCardTypeEnum.COMPONENT:
        return data;
      default:
        <h1>{nodata}</h1>;
    }
  };

  return (
    <div
      className={`applicant-card ${title ? title.toLowerCase().replace(/\s+/g, "-") : ""}`}
    >
      <Grid container spacing={3}>
        <Grid item xs={9}>
          <div
            className={
              title !== "Skills"
                ? "applicant-card-header"
                : "applicant-skillcard-header"
            }
          >
            <h2>{title}</h2>
          </div>
        </Grid>
        <Grid item xs={3} style={{ textAlign: "right" }}>
          {/* {isAccordion && (
                        <div className="expend-icon">
                            <span onClick={handleToggle}>{accordionText}</span>
                            <ExpandCircleDownIcon onClick={handleToggle} />
                        </div>
                    )} */}
          {isAddSection && (
            <div
              className="expend-icon"
              onClick={(e) => {
                onReceiveProps(nodata);
              }}
            >
              <DashboardPlusicon width={28} height={28} />
            </div>
          )}
        </Grid>
      </Grid>
      <div className="applicant-card-details">
        <div className="applicant-card-info">
          {type === jobPostingCardTypeEnum.COMPONENT ? (
            renderingUI(type, data)
          ) : data && data.length > 0 ? (
            renderingUI(type, data)
          ) : type === applicantCardTypeEnum.CUSTOM_LAYOUT ? (
            renderingUI(type, data)
          ) : (
            <h1 className="no-Data">{nodata}</h1>
          )}
        </div>
        {Boolean(isAction) && (
          <div className="applicant-card-action-buttons">
            <Button
              variant="contained"
              className="onHover"
              onClick={() => {
                navigate(actionLink);
              }}
            >
              View all
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ApplicantCard;
